<!--
Timeline Component — wraps PrimeVue Timeline for vertical/horizontal event streams.

Use for chronological lists where each item has a marker (dot/icon) plus
content (and optional opposite content). Pass the events via the `value`
prop; customize the marker, content, and opposite slots as needed.
-->

<template>
  <PrimeTimeline v-bind="$attrs">
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>
  </PrimeTimeline>
</template>

<script setup lang="ts">
import PrimeTimeline from 'primevue/timeline';

defineOptions({ name: 'Timeline', inheritAttrs: false });
</script>
